import React, { useState, useCallback, useEffect } from "react";
import { MdContentCopy } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import img from "../../../assets/GLpageSmapleImages/img.svg";
import GLpageTemplatePopup from "./GLpageTemplatePopup";
import GLPagesService from "../../Services/GLPagesService";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { ToastContainer } from "react-toastify";
import { showSuccessToast } from "../../Constant/Notification";
import { getIcons, userRole } from "../../Constant/Constant";
import { MdOutlineDownloadForOffline } from "react-icons/md";
import CustomHeading from "../../common/CustomHeading";
import { getBackgroundClass } from "../../../Enum/LeadEnumConstants";
import { getBasePathByUserRole } from "../../../utils/roleRoutes";

const defaultImage = img;

const GLpagesViewList = () => {
  const navigate = useNavigate();
  const [openPopup, setOpenPopup] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const icons = getIcons();
  const [GLPagesList, setGLPagesList] = useState([]);
  const [GLpageStatus, setGLpageStatus] = useState(false);
  const [filteredGLPages, setFilteredGLPages] = useState([]);
  const [enquiriesData, setEnquiriesData] = useState({});
  const [loadingEnquiry, setLoadingEnquiry] = useState(null);
  const [nextPropertyId, setNextPropertyId] = useState("");
  const [prevPropertyId, setPrevPropertyId] = useState("");

  const [search, setSearch] = useState("");

  const handleClosePopup = useCallback(() => {
    setOpenPopup(false);
  }, []);

  const path = getBasePathByUserRole()
  const handleGLPageInfo = (id) => {
    navigate(`${path}/gl-pages-creating`, {
      state: { GLPageId: id , isEditMode : true },
    });
  };

  const GetGLPagesList = async (id = "", direction = "next", isInitialLoad = false) => {
    if (isFetching) return;

    setIsFetching(true);
    try {
      const response = await GLPagesService.GetViewGLPages(id, direction);
      if (response) {
        if (isInitialLoad || id === "") {
          setGLPagesList(response?.dataArray || []);
          setFilteredGLPages(response?.dataArray || []);
        } else {
          setGLPagesList((prev) => [...prev, ...response?.dataArray]);
          setFilteredGLPages((prev) => [...prev, ...response?.dataArray]);
        }
        setNextPropertyId(response.next || null);
        setPrevPropertyId(response.prev || null);
      }
    } catch (error) {
      console.error("Error fetching GL Pages:", error.response?.data || error.message);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 100 &&
        !isFetching &&
        nextPropertyId
      ) {
        GetGLPagesList(nextPropertyId, "next");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFetching, nextPropertyId]);

  const downloadExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Enquiries");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  const GetEnquiriesData = async (pageId) => {
    try {
      setLoadingEnquiry(pageId);
      const response = await GLPagesService.GetEnquiries(pageId);
      console.log("Enquiries:", response);

      if (response && response.length) {
        downloadExcel(response, `Enquiries_${pageId}`);
      } else {
        alert("No enquiries data available for download.");
      }
    } catch (error) {
      console.error(
        "Error fetching Enquiries:",
        error.response?.data || error.message
      );
      alert("Failed to fetch enquiries data.");
    } finally {
      setLoadingEnquiry(null);
    }
  };

  const UpdateGlPageStatus = async (id, currentStatus) => {
    if (!id) {
      console.error("GL Page ID is required to update status.");
      return;
    }
    
    const newStatus = !currentStatus;
    setGLPagesList((prevList) =>
      prevList.map((item) =>
        item.id === id
          ? { ...item, data: { ...item.data, status: newStatus } }
          : item
      )
    );

    try {
 
      await GLPagesService.UpdateGLPageStatus(id, newStatus);

      showSuccessToast(
        `Status has been ${newStatus ? "enabled" : "disabled"} successfully`
      );
      
   
      setFilteredGLPages((prevList) =>
        prevList.map((item) =>
          item.id === id
            ? { ...item, data: { ...item.data, status: newStatus } }
            : item
        )
      );
    } catch (error) {
      console.error(
        "Error updating GL Page status:",
        error.response?.data || error.message
      );
      
      // Revert optimistic update on error
      setGLPagesList((prevList) =>
        prevList.map((item) =>
          item.id === id
            ? { ...item, data: { ...item.data, status: currentStatus } }
            : item
        )
      );
      setFilteredGLPages((prevList) =>
        prevList.map((item) =>
          item.id === id
            ? { ...item, data: { ...item.data, status: currentStatus } }
            : item
        )
      );
    }
  };

  const handleCopyToClipboard = (url) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        showSuccessToast("URL copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy URL: ", err);
      });
  };

  useEffect(() => {
    GetGLPagesList("", "next", true); // Pass true for initial load
  }, []);

  useEffect(() => {
    setFilteredGLPages(
      GLPagesList.filter(
        (item) =>
          item.data?.propertyData?.propertyName &&
          item.data?.propertyData?.propertyName
            .toLowerCase()
            .includes(search.toLowerCase())
      )
    );
  }, [search, GLPagesList]);

  const handleTeamplate = () => {
    const path = userRole === "Admin" ? "/admin" : "/cmo";
    navigate(`${path}/gl-pages-template`);
  };

  return (
    <div className="bg-appGrayBackground pt-28">
      <ToastContainer />
       <AdminAppBar />
      <div className="flex px-10 justify-between items-center">
        {/* <div>
          <h1 className="text-3xl font-bold font-poppins text-gray-900">
            GL Property Pages
          </h1>
        </div> */}
        <CustomHeading title={"GL Property Pages"} isIcon={true} />
        <form className=" mx-auto">
          <label
            htmlFor="default-search"
            className=" text-sm font-medium text-gray-900 sr-only"
          >
            Search
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
              <svg
                className="w-4 h-4 text-emerald-700"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              type="search"
              id="default-search"
              className="block w-[500px] p-1 ps-10 h-10 text-sm text-gray-900 border rounded bg-gray-50 border-solid border-slate-400"
              placeholder="Search property"
              required
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </form>

        <div className="flex gap-4 items-center">
          <button
            onClick={handleTeamplate}
            className="border-2 border-customGreen rounded-sm p-1 px-5 mt-2 text-lg text-customGreen h-10 text-center"
          >
            + Create Home Page
          </button>
          <button
            onClick={() => setOpenPopup(!openPopup)}
            className="border-2 border-customGreen rounded-sm p-1 px-5 mt-2 text-lg text-customGreen h-10 text-center"
          >
            + Create New Template
          </button>
        </div>
      </div>
      <div className="mx-auto py-10">
        {filteredGLPages.length > 0 ? (
          <div className="grid px-10 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {filteredGLPages.map((item, index) => (
              <div
                key={item.id}
                className="bg-white p-4 rounded-md shadow-md overflow-hidden"
              >
                <div className="flex justify-between pb-2 items-center">
                  <div>
                    Property:{" "}
                    <span className="font-semibold">
                      {item.data.propertyData?.propertyName || "Default"}
                    </span>
                  </div>

                  <span className="font-semibold cursor-pointer hover:text-emerald-800 text-[18px]">
                    <FiEdit onClick={() => handleGLPageInfo(item.id)} />
                  </span>
                </div>

                <div className="relative">
                  <img
                    src={item.data.hero?.bannerImages?.[0] || defaultImage}
                    alt={item.data.propertyName || "Property"}
                    className="w-full h-40 object-cover rounded-md"
                    loading="lazy"
                  />
                  <div className="absolute top-3 right-3 bg-white p-1.5 rounded-full shadow-md cursor-pointer hover:bg-gray-100">
                    <div className={`${item.data.pageStyle?.color}`}>
                      {item.data.pageStyle?.label}
                    </div>
                  </div>
                </div>

                <div className="flex justify-between items-center bg-gray-50 rounded-lg p-3 mb-4">
                  {/* Total Visits */}
                  <div className="flex flex-col items-center">
                    <span className="font-bold text-lg text-gray-800">{item.data.totalVisits || 0}</span>
                    <span className="text-xs text-gray-600">Visits</span>
                  </div>

                  <div className="w-px h-10 bg-gray-300" />

                  {/* Total Enquiries */}
                  <div className="flex flex-col items-center">
                    <span className="font-bold text-lg text-gray-800">{item.data.totalEnquiries || 0}</span>
                    <span className="text-xs text-gray-600">Enquiries</span>
                  </div>

                  <div className="w-px h-10 bg-gray-300" />

                  {/* Live Status */}
                  <div className="flex flex-col items-center">
                    <label className="inline-flex items-center cursor-pointer mb-1">
                      <input
                        type="checkbox"
                        checked={item.data?.status}
                        onChange={() => UpdateGlPageStatus(item.id, item.data?.status)}
                        className="sr-only peer"
                        aria-label="Toggle Live Status"
                      />
                      <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                    </label>
                    <span className="text-xs text-gray-600">Live Status</span>
                  </div>
                </div>

                {/* Download Enquiries Button */}
                <button
                  onClick={() => GetEnquiriesData(item.id)}
                  className="w-full flex items-center justify-center gap-2 text-emerald-700 hover:text-emerald-800 border border-emerald-600 rounded py-1.5 mb-3 text-sm font-medium hover:bg-emerald-50 transition-colors"
                >
                  <MdOutlineDownloadForOffline className="text-lg" />
                  <span>Download Enquiries</span>
                </button>

                {/* Link with Copy Icon */}
                <div className="cursor-pointer text-sm text-blue-600 flex items-center justify-between rounded border border-gray-300 h-8 overflow-hidden group">
                  <div className="px-2 overflow-hidden whitespace-nowrap text-ellipsis w-full">
                    <a
                      href={`http://crm.glpages.s3-website.ap-south-1.amazonaws.com/gl-page/${item.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline"
                    >
                      {`http://crm.glpages.s3-website.ap-south-1.amazonaws.com/gl-page/${item.id}`}
                    </a>
                  </div>
                  <div
                    onClick={() => handleCopyToClipboard(`http://crm.glpages.s3-website.ap-south-1.amazonaws.com/gl-page/${item.id}`)}
                    className="bg-gray-100 h-full flex items-center px-2 hover:bg-gray-200"
                    title="Copy to clipboard"
                  >
                    <MdContentCopy className="text-gray-700" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center mt-10 text-customGreen font-semibold text-center">
            <label>No GL Pages List</label>
            <img
              src={icons?.glPageEmpty}
              alt="No GL Page"
              className="w-60 md:w-72 lg:w-80 mt-4"
            />
          </div>
        )}
      </div>

      {openPopup && <GLpageTemplatePopup ClosePopup={handleClosePopup} />}
    </div>
  );
};

export default GLpagesViewList;